<template functional>
  <a-sub-menu :key="props.menuInfo.path" class="my-submenu-tag">
    <span slot="title">
      <a-icon
          v-if="props.menuInfo.meta.icon"
          :type="props.menuInfo.meta.icon"
          theme="filled"
      />

      <span v-if="!props.showNext">{{parent.getTitle(props.menuInfo)}}</span>
    </span>
    <template v-for="item in props.menuInfo.children">
      <a-menu-item
          style="border: none"
          v-if="!item.children"
          :key="item.path"
          @click="() =>
          parent.$router.push({ path: item.path, query: parent.$route.query})">
        <span v-if="parent.$i18n.locale">{{parent.getTitle(item) }}</span>
      </a-menu-item>
      <sub-menu v-else :key="item.path" :menu-info="item" />
    </template>
  </a-sub-menu>
</template>
<script>


export default {
  name:'SubMenu',
  props: {
    menuInfo: Object,
    showNext: Boolean,
  },
  beforeCreate() {
  },
  data() {
    return {
      language: localStorage.getItem('i18n')|| 'en'
    }
  },
  methods: {
  }
};


</script>
